var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogopng(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    focusable: "false",
    color: "rgb(255, 255, 255)",
    style: {
      userSelect: "none",
      width: "100%",
      height: "100%",
      display: "inline-block",
      fill: "rgb(255, 255, 255)",
      flexShrink: 0,
      cursor: "auto"
    },
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    color: "rgb(255, 255, 255)",
    weight: "bold",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 128,
    y1: 40,
    x2: 128,
    y2: 216,
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "24px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.8,
    y1: 84,
    x2: 204.2,
    y2: 172,
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "24px"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.8,
    y1: 172,
    x2: 204.2,
    y2: 84,
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "24px"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogopng);
export default __webpack_public_path__ + "static/media/logo.png.9ef55d7e1433d3cd3b35974538e2b7f6.svg";
export { ForwardRef as ReactComponent };